export const PRIORITY_200 = 200

export const SCORECARD_BASE_PERCENTAGE = 40
export const IS_NON_MANUAL_TEXT_UPDATE = 'isNonManualTextUpdate'
export const NON_MANUAL_UPDATE_TYPE = 'nonManualUpdateType'
